<template>
  <div class="structure-img">
    <el-image :src="structureImg" />
  </div>
</template>

<script>
export default {
  name: 'Structure',
  data() {
    return {
      structureImg: require('./images/structure-img.png')
    }
  },
  methods: {
    subMenu(val) {}
  }
}
</script>

<style lang="less" scoped>
</style>
